<div
  *ngIf="showSpinner; else formBlock"
  [mmTestTarget]="'idam-registration-spinner'"
  class="idam-registration__spinner"
>
  <mm-spinner diameter="50"></mm-spinner>
</div>

<ng-template #formBlock>
  <div class="idam-register" [mmTestId]="'IDAM_REGISTER.FORM'">
    <app-advanced-form
      [isFieldDisabled]="disableEmailField"
      [config]="advancedFormConfig"
      (events)="onAdvancedFormEvents($event)"
    >
    </app-advanced-form>

    <div class="idam-register__legal-text">
      <span
        [innerHTML]="
          'PAGES.AUTH.REGISTER.LEGAL_TEXT.TNC'
            | translate: TIER1_SIGNUP_LEGAL_TEXT_PARAMS
        "
      ></span>

      <br /><br />
    </div>
    <div
      class="idam-register__extra-links"
      *ngIf="isTier1ExtraLinks$"
      [innerHTML]="
        'PAGES.AUTH.REGISTER.EXTRA_LINKS'
          | translate: TIER1_SIGNUP_LEGAL_EXTRA_LINKS
      "
    ></div>
  </div>
</ng-template>
